module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0746a_banner_800x600.0c98f8e9.png";